import * as Linking from 'expo-linking';
import Toast from 'react-native-toast-message';

// Org signup (purchase) must happen in the external browser, not in-app —
// app store policy forbids native purchases for this.
export const ORG_SIGNUP_URL = 'https://reachchms.com/signup?ref=app';

export const openOrgSignup = (isWeb) => {
    if (isWeb) {
        // New tab — don't navigate the web app away.
        window.open(ORG_SIGNUP_URL, '_blank', 'noopener');
    } else {
        // External browser (Safari/Chrome), not an in-app webview.
        Linking.openURL(ORG_SIGNUP_URL).catch(() =>
            Toast.show({ type: 'error', text2: 'Could not open the website.' })
        );
    }
};
